'use client';
const IDENT = 'Transition';
const defaultProps = {
    transition: 'fade',
    duration: 250,
    exitDuration: 250,
    mounted: false
};

export { IDENT, defaultProps };
//# sourceMappingURL=Transition.contract.js.map
